package com.narbase.letsgo.web.views.driverGroups

import com.narbase.kunafa.core.components.TextInput
import com.narbase.kunafa.core.components.TextView
import com.narbase.kunafa.core.components.horizontalLayout
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.css.width
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.dto.enum
import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto
import com.narbase.letsgo.web.dto.driverprofilegroup.DriverProfileGroupDto
import com.narbase.letsgo.web.dto.drivertargets.ExtendedTargetDto
import com.narbase.letsgo.web.models.DriverGroupPurpose
import com.narbase.letsgo.web.models.PrizeType
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.views.driverTargets.TargetsManagementViewModel
import kotlin.js.Date

class UpsertDriverGroupDialog(
    private val driverGroup: DriverGroupDto?,
    val onUpdated: () -> Unit
) {
    private val viewModel = UpsertDriverGroupViewModel()
    private val popup by lazy { popUpDialog() }

    var errorTextView: TextView? = null

    private var nameInput: TextInput? = null
    private var driverPurposeDropDownList: RemoteDropDownList<DriverGroupPurpose>? = null

    var selectedDriverGroupPurpose: DriverGroupPurpose? = driverGroup?.purpose?.enum()


    fun show() {
        theme.showDialog(popup) {
            it.bottomBar = {
                horizontalLayout {
                    matchParentWidth()
                    horizontalFiller()
                    theme.unimportantButton(this) {
                        text = "Dismiss".localized()
                        onClick = {
                            popup.dismissDialog()
                        }
                    }
                    horizontalFiller(20)
                    horizontalLayout {
                        style {
                            width = wrapContent
                        }
                        theme.mainButton(this) {
                            text = "Save".localized()
                            onClick = {
                                save()
                            }
                        }.withLoadingAndError(viewModel.upsertUiState, onLoaded = {
                            popup.dismissDialog()
                            onUpdated.invoke()
                        }, onRetryClicked = {
                            save()
                        })
                    }
                }
            }

            mainForm()

        }
    }

    fun LinearLayout.mainForm() = verticalLayout {
        matchParentDimensions()
        nameInput = theme.labeledTextInput(this, "Name")
        nameInput?.text = driverGroup?.name ?: ""
        verticalFiller(10)
        driverPurposeDropDownList = setupDropDownList(
            "Driver Purpose",
            getList = { _, _, _ ->
                DriverGroupPurpose.values()
            },
            itemToString = { it.dtoName },
            onItemSelected = {
                selectedDriverGroupPurpose = it
            },
            defaultItem = selectedDriverGroupPurpose,
            viewWidthFactory = { matchParent },
            showAutoComplete = true,

            )
        verticalFiller(10)

        errorTextView = theme.errorText(this) {
            isVisible = false
        }


    }


    fun save() {

        val name = nameInput?.text?.trim()
        val purpose = selectedDriverGroupPurpose

        if (name.isNullOrBlank()) {
            errorTextView?.text = "Name can't be null"
            errorTextView?.isVisible = true
            return
        }

        if (purpose == null) {
            errorTextView?.text = "Purpose can't be null"
            errorTextView?.isVisible = true
            return

        }

        viewModel.upsert(
            DriverGroupDto(
                id = driverGroup?.id,
                name = name,
                purpose = purpose.dto(),
                createdOn = driverGroup?.createdOn
            )
        )

    }

}